import { Box, CircularProgress, Typography } from "@mui/material";

export default function Spinner() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <CircularProgress color="primary" size={120} />
      <Typography component="h1">Inhalte werden geladen...</Typography>
    </Box>
  );
}